var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        "append-to-body": true,
        width: "800px",
        "show-close": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        top: "2vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "dialog-content",
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.activeName === "20" ? "抬头名称" : "仓库代码",
                    prop: "name",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "672px" },
                    attrs: { placeholder: "仅限除中文的字符" },
                    on: {
                      input: function ($event) {
                        return _vm.onInput("name")
                      },
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              +_vm.activeName === 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "公司名称", prop: "companyName" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "672px" },
                        attrs: { placeholder: "仅限除中文的字符" },
                        on: {
                          input: function ($event) {
                            return _vm.onInput("companyName")
                          },
                        },
                        model: {
                          value: _vm.form.companyName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "companyName", $$v)
                          },
                          expression: "form.companyName",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "国家/省州", prop: "cascader" } },
                [
                  _c("el-cascader", {
                    ref: "myCascader",
                    staticStyle: { width: "320px" },
                    attrs: {
                      placeholder: "请选择国家",
                      options: _vm.addressDropCodeOption,
                    },
                    on: { change: _vm.cascaderChange },
                    model: {
                      value: _vm.form.cascader,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "cascader", $$v)
                      },
                      expression: "form.cascader",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "城市", prop: "cityAddress" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      maxlength: "30",
                      placeholder: "仅限填写数字和英文字符",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onInput("cityAddress")
                      },
                    },
                    model: {
                      value: _vm.form.cityAddress,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "cityAddress", $$v)
                      },
                      expression: "form.cityAddress",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "postcode", label: "邮编" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      placeholder: "仅限填写数字、英文字符和 “ - ”，最多12位",
                      maxlength: 12,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onInput("postcode")
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ item }) {
                          return [
                            _c("div", { staticClass: "name" }, [
                              _vm._v(_vm._s(item.value)),
                            ]),
                            _c("span", { staticClass: "addr" }, [
                              _vm._v(_vm._s(item.address)),
                            ]),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.form.postcode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "postcode", $$v)
                      },
                      expression: "form.postcode",
                    },
                  }),
                ],
                1
              ),
              +_vm.activeName === 0 || +_vm.activeName === 20
                ? _c(
                    "el-form-item",
                    { attrs: { label: "客户", prop: "companyId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "320px" },
                          attrs: { filterable: "", placeholder: "请选择类型" },
                          model: {
                            value: _vm.form.companyId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "companyId", $$v)
                            },
                            expression: "form.companyId",
                          },
                        },
                        _vm._l(_vm.companyDrapdown, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "法人", prop: "contact" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: { placeholder: "仅限除中文的字符" },
                    on: {
                      input: function ($event) {
                        return _vm.onInput("contact")
                      },
                    },
                    model: {
                      value: _vm.form.contact,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "contact", $$v)
                      },
                      expression: "form.contact",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "phoneNumber" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "label-title",
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _vm._v(" 联系电话"),
                      _c("span", [_vm._v("(最少10位，最多15位)")]),
                    ]
                  ),
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      placeholder: "仅限输入数字、英文括号、横杠字符",
                      maxlength: 15,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onInput("phoneNumber")
                      },
                    },
                    model: {
                      value: _vm.form.phoneNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phoneNumber", $$v)
                      },
                      expression: "form.phoneNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱", prop: "email" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: { placeholder: "请填写邮箱" },
                    on: {
                      input: function ($event) {
                        return _vm.onInput("email")
                      },
                    },
                    model: {
                      value: _vm.form.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "email", $$v)
                      },
                      expression: "form.email",
                    },
                  }),
                ],
                1
              ),
              _vm.activeName === "20"
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "taxNum",
                      attrs: { label: "税号", prop: "taxNo" },
                    },
                    [
                      _vm.activeName === "20"
                        ? _c(
                            "span",
                            {
                              staticClass: "form-label",
                              attrs: { slot: "label" },
                              slot: "label",
                            },
                            [
                              _vm._v(" 税号 "),
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "right" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _vm._v(
                                        " 美国EIN号码格式为：12-345678900"
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "离岸进口商EIN号码格式为：123456-78900 "
                                      ),
                                    ]
                                  ),
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/seting/question.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("el-input", {
                        staticStyle: { width: "320px" },
                        attrs: { placeholder: "仅限填写数字和横杠字符" },
                        on: {
                          input: function ($event) {
                            return _vm.onInput("taxNo")
                          },
                        },
                        model: {
                          value: _vm.form.taxNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "taxNo", $$v)
                          },
                          expression: "form.taxNo",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeName === "20"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "类型", prop: "type" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "672px" },
                          attrs: { multiple: "", placeholder: "请选择" },
                          model: {
                            value: _vm.form.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "type", $$v)
                            },
                            expression: "form.type",
                          },
                        },
                        _vm._l(_vm.options, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.activeName === "20"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "MID", prop: "mid" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "672px" },
                        model: {
                          value: _vm.form.mid,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mid", $$v)
                          },
                          expression: "form.mid",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "详细地址", prop: "address" } },
                [
                  _c("el-input", {
                    style: { width: +_vm.activeName === 0 ? "320px" : "672px" },
                    attrs: {
                      placeholder: "仅限除中文的字符，最多输入100位",
                      maxlength: 100,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onInput("address")
                      },
                    },
                    model: {
                      value: _vm.form.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "address", $$v)
                      },
                      expression: "form.address",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取 消")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v(" 确 定 ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }